import { RdPolicyDocument } from '@/features/quotes/components/rd-equipamentos/policy-document.component';
import { requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Apólice RD Equipamentos (ramo 0171) — rota isolada (fora do wizard),
 * aberta pelo "Ver detalhes" da lista de Apólices. Mostra o PDF emitido
 * pela Folheteria, a única apólice do produto. O segmento estático
 * `rd-equipamentos` não conflita com as rotas irmãs `$policyId` de
 * `/quotes` — segmentos estáticos têm precedência sobre dinâmicos no
 * TanStack Router.
 */
export const Route = createFileRoute(
  '/_app/quotes/rd-equipamentos/$proposalId/apolice'
)({
  beforeLoad: async () => {
    const ok = await requirePermissions(['policies.quotes.read']);
    if (!ok) throw redirect({ to: '/dashboard' });
  },
  component: RdApolicePage,
});

function RdApolicePage() {
  const { proposalId } = Route.useParams();
  return <RdPolicyDocument proposalId={proposalId} />;
}
